<template>
  <div class="consultPage">
    <div class="red_bg"></div>
    <div class="title">业务咨询</div>
    <div class="desc">感谢您莅临汉高进博会云展会，填写以下信息便于我们为您提供后续更优质的服务;</div>
    <div class="formWrap">
      <form ref="form">
        <div class="type">
          <div>
            <input type="radio" name="type" id="detergent" v-model="formValue.type" value="洗涤剂及家用护理">
            <label class="label" for="detergent">洗涤剂及家用护理</label>
          </div>
          <div>
            <input type="radio" name="type" id="cosmetic" v-model="formValue.type" value="化妆品/美容用品">
            <label class="label" for="cosmetic">化妆品/美容用品</label>
          </div>
          <div>
            <input type="radio" name="type" id="adhesive" v-model="formValue.type" value="粘合剂技术">
            <label class="label" for="adhesive">粘合剂技术</label>
          </div>
        </div>
        <div class="inputText">
          <label class="label">姓 名:</label>
          <input type="text" name="name" v-model="formValue.name">
        </div>
        <div class="inputText">
          <label class="label">联系方式:</label>
          <input type="tel" name="tel" v-model="formValue.tel">
        </div>
        <div class="inputText">
          <label class="label">公司名称:</label>
          <input type="text" name="company_name" v-model="formValue.company_name">
        </div>
        <div class="inputText">
          <label class="label">职 位:</label>
          <input type="text" name="position" v-model="formValue.position">
        </div>
        <div class="inputText">
          <label class="label">业务咨询:</label>
          <input type="text" name="consulting" v-model="formValue.consulting">
        </div>
      </form>
    </div>
    <div class="button" @click="handleForm">
      <span>提交</span>
    </div>
  </div>
</template>

<script>
const path = '/2021/skd1/?s=shk_ajax'
const initialData = {
  type: '',
  name: '',
  tel: '',
  company_name: '',
  position: '',
  consulting: ''
}
export default {
  name: 'ConsultPage',
  props: {
  },
  data () {
    return {
      formValue: initialData
    }
  },
  mounted () {
    console.log(this.$refs)
    console.log(this.$refs.form)
  },
  methods: {
    checkPhoneNumber (value) {
      if (value === '') {
        return false
      }
      const reg = /^[1][3,4,5,7,8,9][0-9]{9}$/
      return reg.test(value)
    },
    handleForm () {
      if (!this.formValue.type) {
        this.$notice({ type: 'info', message: '请选择咨询类型' })
        return false
      }
      if (!this.formValue.name) {
        this.$notice({ type: 'info', message: '请输入姓名' })
        return false
      }
      if (!this.formValue.tel || !this.checkPhoneNumber(this.formValue.tel)) {
        this.$notice({ type: 'info', message: '请输入正确的手机号码' })
        return false
      }
      if (!this.formValue.company_name) {
        this.$notice({ type: 'info', message: '请输入公司名称' })
        return false
      }
      if (!this.formValue.position) {
        this.$notice({ type: 'info', message: '请输入职位' })
        return false
      }
      this.axios.post(path, this.formValue).then(res => {
        if (res.status === 200 && res.data.code === 0) {
          this.$notice({ type: 'info', message: '提交成功' })
          this.$refs.form.reset()
        } else {
          this.$notice({ type: 'info', message: '提交失败，请重试' })
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='less' scoped>
  .consultPage {
    width: 100%;
    min-height: 100%;
    overflow: auto;
    position: relative;
    box-sizing: border-box;
    overflow-x: hidden;
    padding: 100px 40px 0 40px;

    .red_bg {
      width: 1000px;
      height: 1000px;
      border-radius: 50%;
      top: -20%;
      left: -20%;
      background-color: #e10010;
      position: absolute;
      z-index: -1;
    }

    .title {
      font-size: 44px;
      color: #fff;
    }

    .desc {
      font-size: 30px;
      color: #fff;
      margin-top: 50px;
    }

    .formWrap {
      width: 100%;
      height: 886px;
      padding: 50px;
      position: relative;
      margin-top: 34px;
      font-size: 26px;
      box-sizing: border-box;
      background-color: #fff;
      box-shadow: 0 0 15px rgba(117, 117, 117, 0.3);

      .type {
        margin-bottom: 40px;
        div {
          width: 100%;
          height: 48px;
          display: flex;
          align-items: center;
          label {
            margin-left: 20px;
            display: flex;
            justify-content: center;
          }
        }
        input[type="radio"] {
          display: none;
        }
        input[type="radio"]+label::before {
          content: '';
          width: 30px;
          height: 30px;
          margin-right: 15px;
          display: inline-block;
          background: url('../../assets/img_radio_uncheck.png') no-repeat;
          background-size: contain;
        }
        input[type="radio"]:checked+label::before {
          background: url(../../assets/img_radio_checked.png) no-repeat;
          background-size: contain;
        }
      }

      .inputText {
        margin-bottom: 40px;
        input {
          width: 380px;
          height: 64px;
          border: 2px solid #e10010;
          border-radius: 0;
          -webkit-appearance: none;
          outline: 0;
          padding-left: 20px;
          margin-left: 20px;
        }
        label {
          width: 120px;
          height: 64px;
          line-height: 64px;
          display: inline-block;
          vertical-align: middle;
          text-align: justify;
          text-align-last: justify;
          text-align: justify;
        }
        label::after {
          content: " ";
          display: inline-block;
          background-color: #e10010;
          width: 100%;
        }
      }
      .inputText:last-child {
        input {
          height: 128px;
        }
        label {
          line-height: 100%;
        }
      }
      .button {
        width: 425px;
        height: 80px;
        line-height: 80px;
        position: absolute;
        text-align: center;
        padding-bottom: 50px;
        bottom: -130px;
        border: none;
        color: #fff;
        font-size: 30px;
        left: 50%;
        transform: translateX(-50%);
        background-color: #e10010;
      }
    }
    .button {
      width: 100%;
      height: 80px;
      line-height: 80px;
      text-align: center;
      padding-bottom: 50px;
      color: #fff;
      font-size: 30px;
      margin-top: 40px;
      span {
        width: 425px;
        height: 80px;
        display: inline-block;
        text-align: center;
        line-height: 80px;
        background-color: #e10010;
      }
    }
  }
</style>
